import { render, staticRenderFns } from "./jiaban.vue?vue&type=template&id=041b02fe&scoped=true&"
import script from "./jiaban.vue?vue&type=script&lang=js&"
export * from "./jiaban.vue?vue&type=script&lang=js&"
import style0 from "./jiaban.vue?vue&type=style&index=0&id=041b02fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041b02fe",
  null
  
)

export default component.exports